import React from 'react';
import { OnChangeValue } from 'react-select';
import { ErrorMessage } from './error';
import Creatable from 'react-select/creatable';

export type Option = {
  label: string;
  value: string;
}

type Props = {
  name: string;
  options: Option[];
  onChange?: (name: string, options: Option[]) => void;
  defaultValue?: any[];
  errors?: any;
}

export const CreatableSelect = (props: Props): JSX.Element => {
  const onChange = (event: OnChangeValue<Option, boolean>): void => {
    props.onChange?.(props.name, event as Option[]);
  };
  const className = `multi-select ${props?.errors?.roles ? 'invalid' :''}`;
  return <>
    <Creatable
      isMulti
      defaultValue={props.defaultValue}
      options={props.options}
      onChange={onChange}
      className={className}
      classNamePrefix="pdc"
    />
    {props.errors?.roles?.message && <ErrorMessage>{props.errors.roles.message}</ErrorMessage>}
  </>;
};
